/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type editMicrosite = {|
  _id: string,
  name: string,
  showroomsIds?: ?$ReadOnlyArray<string>,
  portalId: string,
  coverpageId?: ?string,
  templateId?: ?number,
  backgroundImage?: ?any,
  tags?: ?$ReadOnlyArray<string>,
|};
export type EditMicrositeMutationVariables = {|
  microsite?: ?editMicrosite
|};
export type EditMicrositeMutationResponse = {|
  +editMicrosite: ?{|
    +_id?: string,
    +id?: string,
    +name?: string,
    +showroomsIds?: ?$ReadOnlyArray<string>,
    +backgroundImage?: ?string,
    +coverpageId?: ?string,
    +templateId?: ?number,
    +thumbnailUrl?: ?string,
    +portalId?: string,
    +creator?: string,
    +accountId?: string,
    +createdAt?: ?any,
    +updatedAt?: ?any,
    +message?: string,
    +status?: number,
    +success?: boolean,
    +token?: ?string,
    +shared?: ?string,
    +hash?: ?string,
    +userId?: ?string,
    +__typename: "Response",
  |}
|};
export type EditMicrositeMutation = {|
  variables: EditMicrositeMutationVariables,
  response: EditMicrositeMutationResponse,
|};
*/


/*
mutation EditMicrositeMutation(
  $microsite: editMicrosite
) {
  editMicrosite(microsite: $microsite) {
    __typename
    ... on Microsite {
      _id
      id
      name
      showroomsIds
      backgroundImage
      coverpageId
      templateId
      thumbnailUrl
      portalId
      creator
      accountId
      createdAt
      updatedAt
    }
    ... on Response {
      message
      status
      success
      token
      shared
      hash
      userId
      __typename
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "microsite"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "microsite",
    "variableName": "microsite"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showroomsIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coverpageId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creator",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "Microsite",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shared",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hash",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMicrositeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "editMicrosite",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "type": "Response",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMicrositeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "editMicrosite",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "type": "Response",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e6308280b99ae8616ec05d812ae1dad5",
    "id": null,
    "metadata": {},
    "name": "EditMicrositeMutation",
    "operationKind": "mutation",
    "text": "mutation EditMicrositeMutation(\n  $microsite: editMicrosite\n) {\n  editMicrosite(microsite: $microsite) {\n    __typename\n    ... on Microsite {\n      _id\n      id\n      name\n      showroomsIds\n      backgroundImage\n      coverpageId\n      templateId\n      thumbnailUrl\n      portalId\n      creator\n      accountId\n      createdAt\n      updatedAt\n    }\n    ... on Response {\n      message\n      status\n      success\n      token\n      shared\n      hash\n      userId\n      __typename\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'af6b96224ec6b1cedf57dd64dc93947e';

module.exports = node;
